<script lang="ts">
	import type { TableData } from '@repo/commons/models'
	import { Label } from '@repo/commons/components'

	type Props = {
		row: TableData
	}

	const { row }: Props = $props()

	const defaultValue: string = $derived(row.defaultValue)
</script>

<div class="default-value-cell">
	<Label label={defaultValue} variant="default" />
</div>

<style lang="postcss">
	.default-value-cell {
		@apply flex flex-wrap gap-2;
	}
</style>
